import React from 'react';
import "../../styles/hero.css";
import hero from "../../assets/hero.png"
import { useNavigate } from "react-router-dom";


const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-wrapper container">
      <div className="hero-card row align-items-center g-0"> {/* Added g-0 to remove default gutter */}
        
        {/* LEFT TEXT SECTION */}
        <div className="col-lg-6 col-md-12 text-content ps-lg-5">
          <h1 className="hero-title">
            Strong Foundation.<br />
            Bright Future.
          </h1>
          
          <p className="hero-subtitle">
            From 1st to 12th standard – State Board & CBSE – We make 
            learning simple, engaging, and result-oriented.
          </p>

          <div className="hero-buttons" onClick={() => navigate("/contact")}>
            <button className="btn-enroll">Enroll Today For Academic Excellence</button>
          </div>
        </div>

        {/* RIGHT IMAGE SECTION */}
        <div className="col-lg-6 col-md-12 hero-img-container position-relative d-flex justify-content-center align-items-end">
          
          {/* 1. The Background Pattern */}
        {/*   <img 
            src="https://school.madhiacademy.com/wp-content/uploads/sites/2/2025/09/Asset-05-copy.png" 
            alt="Background Pattern" 
            className="hero-pattern"
          /> */}

          {/* 2. The Students Image */}
          <img
            src={hero} 
            alt="Students"
            className="hero-students-img"
          />
        </div>

      </div>
    </section>
  );
};

export default Hero;